import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TenantOption ( props ) {

    return <BasicCrudScreenType id="TenantOption" table="TenantOption" view="VwTenantOption" />;

}

export default TenantOption;
